import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { IClientPortalCreditControlService } from "services/ClientPortalCreditControlService";
import { CreditControlUnitModel } from "services/api/cplapi/CPLAPI";
import { SERVICE_TYPES } from "setup/dependency/ServiceTypes";
import { container } from "setup/dependency/inversify.config";
import { RootState } from "setup/redux/RootReducer";

const initialState = {
  CreditControlUnit: new CreditControlUnitModel(),
  Loading: false,
};

export const CreditControlUnitSummariesSlice = createSlice({
  name: "CreditControlUnitSummaries",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getCreditControlUnitSummaries.pending, (state) => {
        state.Loading = true;
      })
      .addCase(getCreditControlUnitSummaries.fulfilled, (state, action) => {
        state.CreditControlUnit = action.payload;
        state.Loading = false;
      })
      .addCase(getCreditControlUnitSummaries.rejected, (state) => {
        state.CreditControlUnit = new CreditControlUnitModel();
        state.Loading = false;
      });
  },
});

export const getCreditControlUnitSummaries = createAsyncThunk<
  CreditControlUnitModel,
  { developmentID: string; statusID: number }
>("CreditControlUnitSummaries/GetCreditControlUnitSummaries", async ({ developmentID, statusID }) => {
  const creditControlService = container.get<IClientPortalCreditControlService>(
    SERVICE_TYPES.CPLClientPortalCreditControlService
  );
  return await creditControlService.getCreditControlUnitBreakdown(developmentID, statusID);
});

export const selectCreditControlUnitSummaries = (state: RootState) =>
  state.CreditControlUnitSummaries.CreditControlUnit;
export const selectLoadingCreditControlUnitSummaries = (state: RootState) => state.CreditControlUnitSummaries.Loading;

export default CreditControlUnitSummariesSlice.reducer;
